<template>
  <div class="wallet-admin">
    <div
      v-if="!isAdmin"
      class="text-center text-muted py-3"
    >
      No tienes permisos para ver este resumen.
    </div>

    <template v-else>
      <wallet-admin-summary-card
        :summary="summary"
        :loading="loading"
        @refresh="load"
      />

      <wallet-admin-wallets-table
        :items="wallets"
        :loading="loading"
        :pagination="walletsPagination"
        @refresh="load"
        @change-page="onWalletsPageChange"
      />

      <wallet-admin-transactions-table
        :items="transactions"
        :loading="loading"
        :pagination="transactionsPagination"
        @refresh="load"
        @change-page="onTransactionsPageChange"
      />
    </template>
  </div>
</template>

<script>
import WalletAdminSummaryCard from '@/views/wallet/WalletAdminSummaryCard.vue'
import WalletAdminWalletsTable from '@/views/wallet/WalletAdminWalletsTable.vue'
import WalletAdminTransactionsTable from '@/views/wallet/WalletAdminTransactionsTable.vue'

export default {
  name: 'WalletAdminSummary',
  components: {
    WalletAdminSummaryCard,
    WalletAdminWalletsTable,
    WalletAdminTransactionsTable,
  },
  data() {
    return {
      loading: false,
      walletsPagination: {
        page: 1,
        per_page: 25,
        total_objects: 0,
      },
      transactionsPagination: {
        page: 1,
        per_page: 100,
        total_objects: 0,
      },
    }
  },
  computed: {
    isAdmin() {
      const cu = this.$store.getters['auth/currentUser'] || {}
      return cu.role_name === 'admin'
    },
    summary() {
      return this.$store.getters['wallet/walletSummary'] || {}
    },
    transactions() {
      return (this.summary && this.summary.transactions) || []
    },
    wallets() {
      const s = this.summary || {}
      const list = s.wallets || s.wallets_list || s.wallets_summary || s.customers || s.items || []
      return Array.isArray(list) ? list : []
    },
    walletsMeta() {
      const meta = (this.summary && this.summary.meta) || {}
      return meta.wallets_pagination || {}
    },
    transactionsMeta() {
      const meta = (this.summary && this.summary.meta) || {}
      return meta.transactions_pagination || {}
    },
  },
  created() {
    if (this.isAdmin) {
      this.load()
    }
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const resp = await this.$store.dispatch('wallet/fetchWalletSummary', {
          walletsPage: this.walletsPagination.page,
          walletsPerPage: this.walletsPagination.per_page,
          transactionsPage: this.transactionsPagination.page,
          transactionsPerPage: this.transactionsPagination.per_page,
        })
        this.syncPaginationFromResponse(resp)
      } catch (e) {
        const resp = e && e.response
        const msg = (resp && resp.data && (resp.data.error || resp.data.message)) || (e && e.message)
        this.$bvToast.toast(msg || 'Error al cargar resumen de monedero', { variant: 'danger', solid: true })
      } finally {
        this.loading = false
      }
    },
    syncPaginationFromResponse(resp) {
      const meta = (resp && resp.meta) || {}
      const wallets = meta.wallets_pagination || {}
      const transactions = meta.transactions_pagination || {}

      if (wallets.page) this.walletsPagination.page = wallets.page
      if (wallets.per_page) this.walletsPagination.per_page = wallets.per_page
      if (wallets.total_objects != null) this.walletsPagination.total_objects = wallets.total_objects

      if (transactions.page) this.transactionsPagination.page = transactions.page
      if (transactions.per_page) this.transactionsPagination.per_page = transactions.per_page
      if (transactions.total_objects != null) this.transactionsPagination.total_objects = transactions.total_objects
    },
    onWalletsPageChange(page) {
      this.walletsPagination.page = page
      this.load()
    },
    onTransactionsPageChange(page) {
      this.transactionsPagination.page = page
      this.load()
    },
  },
}
</script>

<style scoped>
.wallet-admin {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
